<script type="ts">
	import type { ChatComponent } from '$Chat/helpers/Achord';
	import Achord from '$Chat/Achord.svelte';
	import { setupApp } from '$Chat/helpers/company-chat';
	import Message from '$Chat/Message.svelte';
	import RobotSelector from '$lib/patterns/strategy/components/Robots/RobotSelector.svelte';
	import type { Robot } from '$lib/patterns/strategy/examples/types';

	export let text: string = '';
	export let channel: string = 'watercooler';
	export let timeOffset = 0;
	export let show: string;
	export let group: string;
	export let size: number | undefined;
	export let terminal = false;
	export let scrollToText: string = '';

	const app = setupApp(channel, text, timeOffset);

	let active: ChatComponent[] = [];
	let logs: string[] = ['[Stoicism Bot] Cache: MISS', '[Stoicism Bot] Cache: HIT'];

	function updateActive() {
		active = app.get();
		logs = logs;
	}

	function onInsert(e: CustomEvent<Robot.AchordMessage>) {
		app.insert(Message, e.detail);
		updateActive();

		if (terminal && e.detail.log) {
			logs.push(e.detail.log);
		}
	}

	function onDestroy() {
		const last = app.last();
		if (!last) {
			return;
		}
		app.remove(last);
		updateActive();
	}

	$: if (channel) {
		app.changeChannel(channel);
		active = app.get();
	}

	function shouldActivateBot(text: string) {
		return ['/joke', '/quotes', '/bots', '/bot'].some((x) => text.includes(x));
	}

	function insertBotMenu() {
		console.log(app.lastMessage());
		app.insert(RobotSelector, { show, group });
		updateActive();
	}

	$: if (channel && shouldActivateBot(app.lastMessage())) {
		const entry = active[active.length - 1];
		app.remove(entry.props);
		insertBotMenu()
	}
</script>

<Achord
	{scrollToText}
	channels={app.getChannels()}
	entries={active}
	online={app.online()}
	bind:channel
	on:destroy={onDestroy}
	on:insert={onInsert}
	on:plus={insertBotMenu}
	{size}
>
	{#if terminal && logs.length > 0}
		<div class="terminal">
			<div class="terminal-heading">Logana Konsole</div>
			{#each logs as log}
				<div class="terminal-log">> {log}</div>
			{/each}
		</div>
	{/if}

	{#if import.meta.env.MODE === 'development'}
		<div class="debug-label">
			{show} / {group}
		</div>
	{/if}
</Achord>

<style lang="scss">
	.debug-label {
		position: absolute;
		top: 0;
		right: 0;
		background-color: var(--demo-bg-40);
		padding: 3px 15px;
		border-top-right-radius: $border_radius;
		opacity: 0.8;
		font-size: 13px;
	}
	.terminal {
		background-color: var(--demo-bg-10);
		display: block;
		color: white;
		grid-column: 1 / -1;
		border-bottom-left-radius: $border_radius;
		border-bottom-right-radius: $border_radius;
		font-family: monospace;
		padding: 10px 20px;
	}
	.terminal-heading {
		font-weight: 700;
		color: var(--demo-bg-60);
	}

	.terminal-log {
		padding-left: 25px;
		color: hsl(120, 85%, 46%);
	}
</style>
